import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/employee/[id]/settings/page";

export const Route = createFileRoute("/employee/$id/settings")({
  component: Page,
});
